import { appConfig } from '../../../../../../../../../config/customization';
import { defaultPaddingLeft, mobileDefaultPaddingLeft } from '../../../../../../../../../constants/sizes';
import Device from '../../../../../../../../../constants/deviceSizes';

const container = {
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  boxSizing: 'border-box',
  justifyContent: 'flex-start',
  alignItems: 'flex-start'
};

export default {
  colorContainer: {
    ...container,
    backgroundColor: appConfig.colors.errorScreenBackgroundColor,
    width: '100%',
    padding: `10px ${defaultPaddingLeft}px`,
    [Device.mobile]: {
      padding: `10px ${mobileDefaultPaddingLeft}px`
    }
  },
  lineContainer: {
    ...container,
    width: `calc(100% - ${defaultPaddingLeft}px)`,
    marginBottom: 8,
    padding: `8px 18px`,
    border: `1px solid ${appConfig.colors.bordersGray}`,
    borderRadius: 10,
    [Device.mobile]: {
      width: `calc(100% - ${mobileDefaultPaddingLeft}px)`,
      padding: 8
    }
  },
  data: {
    display: 'flex',
    flex: '1 1 auto',
    alignItems: 'flex-start',
    width: '100%',
    height: '100%',
    flexDirection: 'row',
    marginTop: 10,
    justifyContent: 'space-between',
    [Device.mobile]: {
      flexDirection: 'column'
    }
  },
  chart: {
    flexDirection: 'column',
    position: 'relative',
    width: '60%',
    [Device.desktop_tablet]: {
      flex: '0 1 auto',
      height: '43vh'
    },
    [Device.mobile]: {
      width: '100%',
      height: '50%'
    }
  },
  toggle: {
    height: 22,
    position: 'absolute',
    top: 5,
    zIndex: 2
  },
  progress: {
    width: '40%',
    [Device.desktop_tablet]: {
      height: '100%'
    },
    [Device.mobile]: {
      width: '100%',
      height: '50%'
    }
  }
};
